const styles = {
  container: {
    width: "100%",
    borderBottom: "1px solid rgba(0, 0, 0, 0.25)"
  },
  title: {
    paddingBottom: 10,
    borderBottom: "1px solid rgba(0, 0, 0, 0.25)",
    marginBottom: 10
  }
};

export default styles;



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/styles.js